import { useState } from "react";
import { UtensilsCrossed } from "lucide-react";

export function mediaUrl(value, size = "small", variant = "webp") {
  if (!value || !/^(https?:\/\/|\/api\/)/.test(value)) return "";
  let url = value.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${value}` : value;
  if (url.includes("/api/pos/image-library/") && url.includes("/blob")) {
    const parsed = new URL(url); parsed.searchParams.set("variant", size === "small" ? "thumb" : "original"); url = parsed.toString();
  }
  if (url.includes("/api/pos/qr-menu/media/") && url.includes("/blob")) {
    const parsed = new URL(url); parsed.searchParams.set("size", size); parsed.searchParams.set("variant", variant); url = parsed.toString();
  }
  return url;
}
export function QrMedia({ src, alt, size = "small", className = "", priority = false, testId }) {
  const [failedSrc, setFailedSrc] = useState(null);
  const original = mediaUrl(src, size);
  const libraryId = original.match(/\/api\/pos\/image-library\/([a-f0-9]{32})\/blob/);
  // Image-library photos: served as cached WebP at display size (960 for large, 256 for cards) instead of the raw blob.
  const url = libraryId ? `${process.env.REACT_APP_BACKEND_URL}/api/public/qr-images/${libraryId[1]}?size=${size === "large" ? 960 : 256}` : original;
  const managed = url.includes("/api/pos/qr-menu/media/");
  if (!url || failedSrc === src) return <div className={`qr-image-placeholder ${className}`} role="img" aria-label={`${alt} — photo unavailable`} data-testid={testId} data-photo-state={!url ? "missing" : "failed"}>
    <UtensilsCrossed size={28} strokeWidth={1.25} aria-hidden="true" />
  </div>;
  return <picture className={`qr-picture ${className}`} data-testid={testId}>
    {managed && <source type="image/webp" srcSet={url} />}
    <img src={managed ? mediaUrl(src, size, "jpeg") : url} alt={alt} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"}
      decoding="async" onError={() => setFailedSrc(src)} />
  </picture>;
}